import { useState } from "react";
import { fetchApi, getUserCookie, User } from "./data";
import { config } from "process";

export const AboutPanel = () => {
  const userCookie = getUserCookie();
  // console.log("userCookie", userCookie);
  let showInit = "";
  let nameInit = "";
  if (userCookie) {
    showInit = "show-logout" + (userCookie.admin === "1" ? " show-admin" : "");
    nameInit = userCookie.email;
  }

  const [show, setShow] = useState<string>(showInit);
  const [isLogin, setIsLogin] = useState<boolean>(!!userCookie);
  const [admin, setAdmin] = useState<string>(userCookie?.admin || "");
  const [users, setUsers] = useState<User[]>([]);

  const doSendCode = async () => {
    // console.log("doSendCode");
    const emailDom = document.querySelector(".uname") as HTMLInputElement;
    const email = emailDom.value;
    if (!email) {
      alert("Please enter email");
      return;
    }
    const res = await fetchApi("/api/send-code", {
      email,
    });
    // console.log(res);
    // if (res.json.status === "success") {
    alert(res.json && res.json.message);
    // } else {
    //   alert(res.json.message);
    // }
  };
  const doLogin = async () => {
    // console.log("doLogin");
    const emailDom = document.querySelector(".uname") as HTMLInputElement;
    const email = emailDom.value;
    const codeDom = document.querySelector(".ucode") as HTMLInputElement;
    const code = codeDom.value;
    if (!email || !code) {
      alert("Please enter email and code");
      return;
    }
    const res = await fetchApi("/api/verify-code", {
      email,
      code,
    });
    // console.log(res);
    if (res.json && res.json.status === "success") {
      setShow(
        "show-logout" + (res.json.user.admin === "1" ? " show-admin" : "")
      );
      setIsLogin(true);
      setAdmin(res.json.user.admin);
    } else {
      alert(res.json && res.json.message);
    }
  };
  const doLogout = () => {
    document.cookie =
      "userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    setShow("");
    setIsLogin(false);
    setAdmin("");
  };
  const doRefreshUsers = async () => {
    const res = await fetchApi("/api/users");
    // console.log(res);
    if (res.json && res.json.status === "success") {
      setUsers(res.json.users);
    } else {
      alert(res.json && res.json.message);
    }
  };
  const doBlockUser = async (email: string, block: string) => {
    const res = await fetchApi("/api/update-user", {
      email,
      block,
    });
    // console.log(res);
    // if (res.json.status === "success") {
    alert(res.json && res.json.message);
    // } else {
    //   alert(res.json.message);
    // }
    doRefreshUsers();
  };
  const doAdmin = () => {
    setShow("show admin-part");
    doRefreshUsers();
    doReadEnv();
  };
  const doReadEnv = async () => {
    const envDom = document.querySelector(".uenv") as HTMLInputElement;
    const res = await fetchApi("/api/read-env");
    // console.log(res);
    if (res.json && res.json.status === "success") {
      envDom.value = res.json.envText;
    } else {
      alert(res.json && res.json.message);
    }
    };
  const doUpdateEnv = async () => {
    if (!window.confirm("Are you sure to update env, it may cause unexpected behavior?")) {
      return;
    }
    const envDom = document.querySelector(".uenv") as HTMLInputElement;
    const res = await fetchApi("/api/update-env", {
      envText: envDom.value,
    });
    alert(res.json && res.json.message);
    doReadEnv();
  };
  return (
    <div className={"about-panel " + show}>
      {!isLogin && (
        <div className="login-row">
          <div
            className="login-link"
            onClick={() => setShow("show login-part")}
          >
            Login
          </div>
        </div>
      )}

      {isLogin && (
        <div className="logout-row">
          Hi, {nameInit}
          <div className="logout-link" onClick={doLogout}>
            Logout
          </div>
          {admin === "1" && <div onClick={doAdmin}>Admin</div>}
        </div>
      )}

      <div className="about-link" onClick={() => setShow("show about-part")}>
        About
      </div>
      <div
        className="details"
        style={{
          height: "100%",
          overflowY: "auto",
          backgroundColor: "#fefefe",
        }}
      >
        <div className="close-link" onClick={() => setShow("")}>
          X
        </div>
        <div className="detail-box login-box" style={{ marginBottom: "60px" }}>
          <h1>Login</h1>
          <div>
            <div className="text-field w100p">
              <input
                className="text-base w100p uname"
                type="text"
                required
                placeholder=" "
              />
              <span>Email *</span>
            </div>

            <button
              className="button-base"
              style={{ width: "160px", height: "20px" }}
              onClick={doSendCode}
            >
              Send Verification Code
            </button>
            <div className="text-field w100p">
              <input
                className="text-base w100p ucode"
                type="text"
                required
                placeholder=" "
              />
              <span>Verification Code *</span>
            </div>
            <button
              className="button-base"
              style={{ width: "100px" }}
              onClick={doLogin}
            >
              Login
            </button>
          </div>
        </div>
        <div className="detail-box admin-box" style={{ marginBottom: "60px" }}>
          <div style={{ paddingRight: "10px" }}>
            <div style={{ display: "flex" }}>
              <h3>Configuration Env:</h3>
              <button
                style={{ alignSelf: "end", cursor: "pointer" }}
                className="logout-link"
                onClick={doUpdateEnv}
              >
                Update
              </button>
            </div>
            <textarea
              className="text-base w100p uenv"
              style={{ width: "100%", height: "100px" }}
            />
          </div>
          <div>
            <div style={{ display: "flex" }}>
              <h3>Users:</h3>
              <button
                style={{ alignSelf: "end", cursor: "pointer" }}
                className="logout-link"
                onClick={doRefreshUsers}
              >
                Refresh
              </button>
            </div>
            {users.map((user) => (
              <div key={user.email} style={{ display: "flex" }}>
                <div>{user.email}</div>
                <div style={{ padding: "0 4px" }}>
                  {user.block === "1" ? "Blocked" : "Active"}
                </div>
                <button
                  style={{ cursor: "pointer" }}
                  className="logout-link"
                  onClick={() =>
                    doBlockUser(user.email, user.block === "1" ? "0" : "1")
                  }
                >
                  {user.block === "1" ? "Unblock" : "Block"}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="detail-box about-box" style={{ marginBottom: "60px" }}>
          <h1>
            3DisoGalaxy: Exploring the Alternative Splicing Landscape in Breast
            Cancer
          </h1>
          Welcome to <b>3DisoGalaxy</b>, a comprehensive resource focused on
          unraveling the diversity of alternative splicing (AS) protein isoforms
          specifically related to breast cancer. This platform is designed to
          support researchers in exploring potential therapeutic targets by
          visualizing the structural similarity network of protein isoforms
          derived from AS events. The 3DisoGalaxy resource primarily serves to
          illuminate the AS landscape in breast cancer, highlighting both common
          and unique isoforms, as well as their associations with different
          breast cancer subtypes. This interactive platform allows users to
          explore a vast network where each node represents a distinct protein
          isoform, and edges between nodes denote structural similarity,
          computed using TM-score values. All edges correspond to structural
          similarities with a TM-score of 0.9 or above, meaning the connected
          isoforms share highly similar 3D structures. The edge color, ranging
          from red to yellow, indicates the degree of similarity: the redder the
          edge, the closer the TM-score is to 1.0, representing near-identical
          structural folds between isoforms. The nodes in this network are
          annotated with metadata from long-read mRNA sequencing, providing
          insights into where these isoforms were detected across different
          breast cancer tissues and subtypes. Node color coding reflects
          tissue-specific expression patterns, with nodes grouped according to
          the breast cancer subtype in which the corresponding isoform was most
          prominently detected. Furthermore, node size is proportional to the
          magnitude of differential expression (log2 fold change), specifically
          highlighting isoforms that are significantly upregulated in basal-like
          breast cancer subtypes. Larger nodes represent isoforms with greater
          upregulation, potentially offering clues to subtype-specific
          functional roles and therapeutic targetability.{" "}
          <h3> Navigating the Network</h3>
          <b>Zooming and Clicking on a Node</b>: Zoom in by scrolling to explore
          different regions of the network. Clicking on any node opens a
          detailed sidebar displaying information about the selected isoform,
          including its gene symbol, associated breast cancer subtype, and log2
          fold change in basal-like cancers. This sidebar also provides detailed
          summaries of the structural comparisons between isoforms. -
          <b>Searching by Gene Symbol or Protein ID</b>: The search bar in the
          upper left corner allows users to query the network by gene symbol or
          protein identifier. Entering a valid gene symbol will zoom into the
          relevant node and display the corresponding isoform(s), along with
          structural and expression-related data. If no exact match is found in
          the dataset, the platform will attempt a structural alignment to find
          proteins with similar structures, helping researchers identify
          potentially related isoforms across the AS landscape. -{" "}
          <b>Query by Structural Similarity</b>: Users can upload protein
          sequences or PDB files to search for structurally similar isoforms
          within the 3DisoGalaxy network. This functionality leverages the
          FoldSeek algorithm to align user-provided structures with isoforms in
          the network. Matched results are displayed as nodes, with neighboring
          similar isoforms highlighted to enable exploration of structural
          neighborhoods. - <b>Query by Alternative Splicing Features</b>: Users
          can search for specific alternative splicing patterns or protein
          domains. This is particularly useful when investigating isoforms that
          may possess unique structural features or domains implicated in breast
          cancer progression or therapy resistance.
          <h3> Exploring the Breast Cancer AS Landscape</h3> The 3DisoGalaxy
          platform enables researchers to visualize the complex network of
          AS-derived isoforms in the context of breast cancer. By grouping
          isoforms into communities based on structural similarity and
          expression profiles, this network highlights both conserved and novel
          protein structures. Each community is represented by one or more
          connected components, which may correspond to clusters of isoforms
          from the same or different breast cancer subtypes. The ability to
          color nodes by tissue specificity, subtype, and fold change helps
          researchers identify potential AS-driven therapeutic targets. -{" "}
          <b>Tissue-specific Expression and Subtype Annotation</b>: The nodes
          are colored according to the breast cancer subtype or tissue in which
          they are most abundantly expressed. This visual feature enables users
          to quickly identify which isoforms are characteristic of different
          breast cancer subtypes, such as luminal A, luminal B, HER2-enriched,
          or basal-like. - <b>Structural Outliers</b>: Some isoforms are flagged
          as structural outliers, indicating that their predicted structure
          deviates significantly from known protein folds in the PDB. These
          outliers may represent novel AS events leading to unique structural
          conformations, potentially with functional implications in cancer
          biology. <h3>Downloading and Offline Exploration</h3> All data
          displayed on 3DisoGalaxy, including network annotations, structural
          alignments, and expression data, can be exported in various formats
          (CSV, TSV, JSON). This allows for offline analysis and integration
          with other datasets. Researchers can download specific connected
          components or the entire dataset to explore relationships between
          AS-derived isoforms in greater depth.
          <h3>Example Use Cases</h3> 1.{" "}
          <b>Finding Novel Isoforms in Breast Cancer</b>: Use the search box to
          input a gene symbol (e.g., <b>BRCA1</b>) to locate AS isoforms
          associated with that gene. The network will zoom in on the relevant
          node(s), displaying information on its expression in different breast
          cancer subtypes and its structural similarity to other isoforms. 2.{" "}
          <b>Exploring Potential Therapeutic Targets</b>: By analyzing nodes
          with large sizes (indicating significant upregulation in basal-like
          breast cancer), users can identify isoforms that may serve as
          potential drug targets. Detailed structural information and links to
          external databases provide further insights into the druggability of
          these targets. 3. <b>Comparing Isoform Structures</b>: Upload a PDB
          file to compare a known protein structure with isoforms in the
          network. 3DisoGalaxy will return isoforms with similar structures,
          allowing researchers to explore possible functional or therapeutic
          relationships between structurally similar proteins.
          <h3>Visualizing Breast Cancer Isoform Diversity</h3> The network
          offers several interactive visualizations to enhance understanding of
          the AS landscape: - <b>Functional Brightness</b>: Nodes are shaded to
          represent the extent of functional annotation available for each
          isoform. Bright nodes have well-characterized domains and families,
          while dark nodes may represent uncharacterized or novel proteins. -{" "}
          <b>Semantic Diversity</b>: Adjust the semantic diversity slider to
          filter nodes based on the variety of descriptions associated with
          isoforms within the same connected component. This helps highlight
          communities with diverse or unique functional annotations. -{" "}
          <b>Subtype-specific Networks</b>: Users can apply filters to view
          isoforms that are specific to certain breast cancer subtypes. This is
          particularly useful for studying subtype-specific alternative splicing
          events and their potential role in cancer progression or treatment
          resistance.<h3>Acknowledge</h3> We would like to extend our sincere
          gratitude to Cosmograph: GPU-accelerated Force Graph Layout and
          Rendering [Computer software]. Rokotyan, N., Stukova, O., Kolmakova D.
          & Ovsyannikov, D. (2022) for providing an intuitive and efficient
          platform for visualizing protein similarity networks, enabling us to
          rapidly explore complex topologies and cluster associations within our
          study. The ability to present these networks clearly played a crucial
          role in interpreting the relationships between protein structures and
          functions. We are also thankful to{" "}
          <b>
            <a href="https://molstar.org/">Mol</a>
          </b>{" "}
          for its advanced capabilities in visualizing protein structures in
          three dimensions. This tool allowed us to explore structural details
          and interactions with precision, offering critical insights into the
          underlying mechanisms of protein similarity and their biological
          relevance in the context of metastasis prediction. These visualization
          tools have been invaluable for data interpretation and for presenting
          our findings in an accessible, clear manner.
          <h3>Privacy and License</h3>
          3DisoGalaxy values user privacy and does not collect personal data.
          Data collected for performance analytics is anonymized, and no
          personal information is transmitted to third-party services. The
          resource operates under a Creative Commons Attribution 4.0
          International License, allowing researchers to freely use, adapt, and
          share the data and tools provided, with proper attribution to the
          3DisoGalaxy project. 3DisoGalaxy was developed by the{" "}
          <b>Xin WANG’s Lab</b>. We thank our contributors and collaborators for
          their support in developing this tool, which we hope will provide
          valuable insights into the role of alternative splicing in breast
          cancer. For inquiries or technical support, please{" "}
          <a href="tjiang@surgery.cuhk.edu.hk">contact us</a>.<p></p>
          <p></p>
        </div>
      </div>
    </div>
  );
};
